export interface Bonus {
  label: string
  title: string
  body: string
}

export const bonuses: Bonus[] = [
  {
    label: '🎁 BONUS 1',
    title: 'NURSING CLINICAL DOCUMENTATION & HANDOVER TOOLKIT™',
    body: 'Organize patient assessments, shift reports, clinical observations, fluid balance records, device monitoring, patient transfers, and professional communication with ready-to-adapt documentation templates and SBAR handover tools.',
  },
  {
    label: '🎁 BONUS 2',
    title: 'NURSING PATIENT SAFETY & RISK PREVENTION TOOLKIT™',
    body: 'Support patient safety with structured fall risk assessments, pressure injury prevention checklists, infection control references, medical device safety forms, clinical deterioration monitoring, and risk prevention workflows.',
  },
  {
    label: '🎁 BONUS 3',
    title: 'NURSING MEDICATION CALCULATION & VERIFICATION WORKBOOK™',
    body: 'Practice medication calculations with structured dosage worksheets, unit conversion references, weight-based calculations, infusion rate exercises, independent verification templates, worked examples, and medication error recognition activities.',
  },
  {
    label: '🎁 BONUS 4',
    title: 'NURSING CLINICAL SCENARIO & DECISION-MAKING WORKBOOK™',
    body: 'Develop clinical reasoning through realistic educational patient scenarios covering respiratory deterioration, cardiovascular assessment, wound care, medication safety, neurological changes, clinical prioritization, and structured communication.',
  },
  {
    label: '🎁 BONUS 5',
    title: 'NURSING SHIFT ORGANIZATION & CLINICAL WORKFLOW PLANNER™',
    body: 'Organize nursing responsibilities with shift planning templates, patient priority worksheets, clinical monitoring schedules, task tracking systems, care coordination forms, safety reviews, and structured handover preparation tools.',
  },
]
